import { useRecoilState } from 'recoil';
import { tokenState } from '../atoms/token';
import { BaseServiceAsyncT } from '../common/services/base-async-T-Id.service';
import environment from '../environment/environment';

export default class APIService<T> extends BaseServiceAsyncT<string, T> {
  
  constructor(axios: any, cacheService: any, url: string, token?: string) { 
    super(axios, cacheService, url);
    console.log('APIService token', token);
    
    // In public mode, never use tokens or credentials
    if (!environment.publicMode) {
      let access_token_from_storage = localStorage.getItem(`access_token`) ?? token;
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token_from_storage;
      axios.defaults.withCredentials = true;
    } else {
      axios.defaults.withCredentials = false;
    }
  }
    newRecord = false;    
}